export enum actions {
  SET_MODAL_TOGGLE = 'SET_MODAL_TOGGLE'
}
